import InputGroupContent from '@/components/elements/input'
import Select from '@/components/elements/select'
import TextareaGroupContent from '@/components/elements/textarea'
import {
	BuyFormat,
	GeneralDetailsSupplements,
	NutritionalInformation,
	SpecificationsSupplements,
} from '@/entities/api/products/details'
import ProductEntity from '@/entities/api/products/products'
import { booleanMap } from '@/utils/maps/boolean-map'
import { containerSupplemntMap } from '@/utils/maps/container-supplement-map'
import { formatSupplemntMap } from '@/utils/maps/format-supplement-map'
import { nutritionalValueMap } from '@/utils/maps/nutritional-value.map'
import { Box, Heading } from '@chakra-ui/react'
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form'

const SupplementsForm = ({
	control,
	register,
	errors,
	product,
}: {
	control: Control<any>
	register: UseFormRegister<any>
	errors: FieldErrors<any>
	product?: ProductEntity
}) => {
	return (
		<>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Detalles generales
				</Heading>
			</Box>
			<InputGroupContent
				label='Marca del suplemento y referencia'
				placeholder='Agrega la marca del suplemento y una referencia'
				name='details.general_details.brand'
				type='text'
				required
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsSupplements)
							.brand) ||
					''
				}
				register={register}
				errors={errors}
			/>
			<InputGroupContent
				label='Principal ingrediente'
				placeholder='Agrega el ingrediente principal del suplemento'
				name='details.general_details.principal_supplement'
				type='text'
				required
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsSupplements)
							.principal_supplement) ||
					''
				}
				register={register}
				errors={errors}
			/>
			<InputGroupContent
				label='Tipo de suplemento'
				placeholder='Agrega el tipo de suplemento (Proteina, Creatina...)'
				name='details.general_details.type'
				type='text'
				required
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsSupplements)
							.type) ||
					''
				}
				register={register}
				errors={errors}
			/>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Especificaciones
				</Heading>
			</Box>
			<Select
				name='details.specifications.is_gluten_free'
				label='¿Es libre de gluten?'
				placeholder='Escoge si el suplemento tiene gluten'
				options={booleanMap}
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.specifications as SpecificationsSupplements)
								?.is_gluten_free ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.specifications.is_vegan'
				label='¿Es Vegano?'
				placeholder='Escoge si el suplemento es vegano'
				options={booleanMap}
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.specifications as SpecificationsSupplements)
								?.is_vegan ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.specifications.have_lactose'
				label='¿Tiene lactosa?'
				placeholder='Escoge si el suplemento tiene lactosa'
				options={booleanMap}
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.specifications as SpecificationsSupplements)
								?.have_lactose ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Informacion nutricional
				</Heading>
			</Box>
			<TextareaGroupContent
				label='Ingredientes del suplemento'
				placeholder='Ingresa los ingredientes del suplemento'
				name='details.nutritional_information.ingredients'
				required
				type='text'
				defaultValue={
					(product &&
						(
							product?.details
								?.nutritional_information as NutritionalInformation
						).ingredients) ||
					''
				}
				register={register}
				errors={errors}
			/>
			<Select
				label='Valor nutricional por porcion (5g de creatina pura)'
				placeholder='Escoge el valor en gramos del producto'
				name='details.nutritional_information.nutritional_portion_value'
				options={nutritionalValueMap}
				defaultValue={
					product &&
					(nutritionalValueMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.nutritional_information as NutritionalInformation
							)?.nutritional_portion_value ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				label='Gramos por porcion o tamaño (30g)'
				placeholder='Escoge el valor en gramos del producto'
				name='details.nutritional_information.portion_weight'
				options={nutritionalValueMap}
				defaultValue={
					product &&
					(nutritionalValueMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.nutritional_information as NutritionalInformation
							)?.portion_weight ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Formato del suplemento
				</Heading>
			</Box>
			<Select
				name='details.buy_format.suplement_format'
				label='Presentacion del suplemento'
				placeholder='Escoge la presentacion del suplemento'
				options={formatSupplemntMap}
				defaultValue={
					product &&
					(formatSupplemntMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.buy_format as BuyFormat)?.suplement_format ??
								'')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.buy_format.container_type'
				label='Material del contenedor del suplemento'
				placeholder='Escoge el material del contenedor del suplemento'
				options={containerSupplemntMap}
				defaultValue={
					product &&
					(containerSupplemntMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.buy_format as BuyFormat)?.container_type ??
								'')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
		</>
	)
}

export default SupplementsForm
